module.exports = __webpack_public_path__ + "static/media/ig.142bf042.svg";